import axios from "../../http";
import {
  STORE_SETTINGS_PUBLIC_REQUEST,
  STORE_SETTINGS_PUBLIC_SUCCESS,
  STORE_SETTINGS_PUBLIC_FAIL,
} from "../Constants/StoreSettingConstants";

export const getPublicStoreSettings = () => async (dispatch) => {
  try {
    dispatch({ type: STORE_SETTINGS_PUBLIC_REQUEST });

    const { data } = await axios.get("/api/store-settings/public");

    dispatch({
      type: STORE_SETTINGS_PUBLIC_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STORE_SETTINGS_PUBLIC_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getNextWhatsappNumber = async () => {
  const { data } = await axios.get("/api/store-settings/public/next-whatsapp");
  return data.whatsappNumber;
};